import { gql } from '@apollo/client';

export const GET_CHATBOT_CHATS = gql`
  query ChatbotChats($params: FindChatbotChatListInput!) {
    chatbotChats(params: $params) {
      success
      message
      errors
      data {
        chats {
          id
          tenantId
          userId
          title
          lastMessageAt
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_CHATBOT_MESSAGES = gql`
  query ChatbotMessages($params: FindChatbotMessageListInput!) {
    chatbotMessages(params: $params) {
      success
      message
      errors
      data {
        messages {
          id
          chatId
          tenantId
          userId
          role
          content
          feedback
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;
